class UserModel {
  constructor({
    id = "",
    name = "",
    email = "",
    token = "",
    tierId = null,
    tier = {},
    videoCallTimeRemaining = 0,
    voiceCallTimeRemaining = 0,
    planExpirationDate = "",
    messagingRemaining = 0,
    videoCallUsage = 0,
    maxVideoCallTime = 0,
    currentVideoCallUsage = 0,
  } = {}) {
    this._id = id;
    this._name = name;
    this._email = email;
    this._token = token;
    this._tierId = tierId;
    this._tier = tier;
    this._videoCallUsage = videoCallUsage;
    this._videoCallTimeRemaining = videoCallTimeRemaining;
    this._voiceCallTimeRemaining = voiceCallTimeRemaining;
    this._planExpirationDate = planExpirationDate;
    this._messagingRemaining = messagingRemaining;
    this._maxVideoCallTime = maxVideoCallTime;
    this._currentVideoCallUsage = currentVideoCallUsage;

  }

  get id() {
    return this._id;
  }

  set id(value) {
    if (typeof value !== "string") {
      throw new Error("ID must be a string");
    }
    this._id = value;
  }

  get name() {
    return this._name;
  }

  set name(value) {
    if (typeof value !== "string") {
      throw new Error("Name must be a string");
    }
    this._name = value;
  }

  get email() {
    return this._email;
  }

  set email(value) {
    if (typeof value !== "string") {
      throw new Error("Email must be a string");
    }
    this._email = value;
  }

  get token() {
    return this._token;
  }

  set token(value) {
    if (typeof value !== "string") {
      throw new Error("Token must be a string");
    }
    this._token = value;
  }

  get tierId() {
    return this._tierId;
  }

  set tierId(value) {
    if (typeof value !== "string") {
      throw new Error("tierId must be a string");
    }

    this._tierId = value;
  }

  get tier() {
    return this._tier;
  }

  set tier(value) {
    if (typeof tier !== "object") {
      throw new Error("tier must be a object");
    }
    this._tier = value;
  }

  get voiceCallTimeRemaining() {
    return this._voiceCallTimeRemaining;
  }

  set voiceCallTimeRemaining(value) {
    if (typeof value !== "number") throw new Error("VoiceCallTimeRemaining must be a number");

    this._voiceCallTimeRemaining = value;
  }
  get maxVideoCallTime() {
    return this._maxVideoCallTime;
  }

  set maxVideoCallTime(value) {
    if (typeof value !== "number") throw new Error("maxVideoCallTime must be a number");

    this._maxVideoCallTime = value;
  }
  get currentVideoCallUsage() {
    return this._currentVideoCallUsage;
  }

  set currentVideoCallUsage(value) {
    if (typeof value !== "number") throw new Error("maxVideoCallTime must be a number");

    this._currentVideoCallUsage = value;
  }

  get videoCallTimeRemaining() {
    return this._videoCallTimeRemaining;
  }

  set videoCallTimeRemaining(value) {
    if (typeof value !== "number") throw new Error("videoCallTimeRemaining must be a number");

    this._videoCallTimeRemaining = value;
  }

  get messagingRemaining() {
    return this._messagingRemaining;
  }

  set messagingRemaining(value) {
    if (typeof value !== "number") throw new Error("messagingRemaining must be a number");

    this._messagingRemaining = value;
  }

  get planExpirationDate() {
    return this._planExpirationDate;
  }

  set planExpirationDate(value) {
    if (typeof value !== "string") throw new Error("planExpirationDate must be a string");

    this._planExpirationDate = value;
  }

  get videoCallUsage() {
    return this._videoCallUsage;
  }

  set videoCallUsage(value) {
    if (typeof value !== "number") throw new Error("videoCallUsage must be a number");
    this._videoCallUsage = value;
  }

  copyWith({
    id,
    name,
    email,
    token,
    tierId,
    tier,
    videoCallTimeRemaining,
    voiceCallTimeRemaining,
    planExpirationDate,
    messagingRemaining,
    videoCallUsage,
    maxVideoCallTime,
    currentVideoCallUsage,
  }) {
    return new UserModel({
      id: id !== undefined ? id : this._id,
      name: name !== undefined ? name : this._name,
      email: email !== undefined ? email : this._email,
      token: token !== undefined ? token : this._token,
      tierId: tierId !== undefined ? tierId : this._tierId,
      tier: tier !== undefined ? tier : this._tier,
      videoCallUsage: videoCallUsage !== undefined ? videoCallUsage : this._videoCallUsage,
      maxVideoCallTime: maxVideoCallTime !== undefined ? maxVideoCallTime : this._maxVideoCallTime,
      currentVideoCallUsage: currentVideoCallUsage !== undefined ? currentVideoCallUsage : this._currentVideoCallUsage,
      videoCallTimeRemaining: videoCallTimeRemaining !== undefined ? videoCallTimeRemaining : this._videoCallTimeRemaining,
      voiceCallTimeRemaining: voiceCallTimeRemaining !== undefined ? voiceCallTimeRemaining : this._voiceCallTimeRemaining,
      planExpirationDate: planExpirationDate !== undefined ? planExpirationDate : this._planExpirationDate,
      messagingRemaining: messagingRemaining !== undefined ? messagingRemaining : this._messagingRemaining,
    });
  }

  toJSON() {
    return {
      id: this._id,
      name: this._name,
      email: this._email,
      token: this._token,
      tierId: this._tierId,
      tier: this._tier,
      videoCallUsage: this._videoCallUsage,
      videoCallTimeRemaining: this._videoCallTimeRemaining,
      voiceCallTimeRemaining: this._voiceCallTimeRemaining,
      planExpirationDate: this._planExpirationDate,
      messagingRemaining: this._messagingRemaining,
      maxVideoCallTime: this._maxVideoCallTime,
      currentVideoCallUsage: this._currentVideoCallUsage,
    };
  }
}

export default UserModel;
